import React, { Component } from "react";
import { Row, Col, Container } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import FilterSection from "./FilterSection";
import AboveFilterDesc from "./TopMenu";
import OfflineEventDetailsMain from "./OfflineEventTable/OfflineEventDetailsMain";
import Switch from "react-switch";
import Media from "react-media";
import Alert from "react-s-alert";
import SocketContext from "../../../../function/SocketContext";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import {
  get_single_rsvp_event_information,
  fetch_single_event_rsvp_data_information,
  fetch_single_event_pending_data_information,
  fetch_single_event_ticket_data_information,
} from "../../../../store/actions/RsvpEventDashboard/RsvpEventDashboardAction";
import { vendor_update_events } from "../../../../store/actions/vendorOffersAndEventsAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";

class OfflineEventDetailsScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pathname: this.props.location.pathname,
      getSingleEventInfo: {},
      getRsvpData: [],
      getPendingData: [],
      getTicketData: [],
    };
  }

  componentDidMount() {
    if (
      this.props.location.state !== null &&
      this.props.location.state !== undefined
    ) {
      this.props.get_single_rsvp_event_information(
        this.props.location.state.offlineEventInformation,
        this.props.auth.user.accessToken,
        this.onSuccessClick(this.props.location.state.offlineEventInformation)
      );
    } else if (this.props.location.pathname) {
      let id = this.props.location?.pathname?.split("/")[1];
      this.props.history.push({
        pathname: this.props.location.pathname,
        state: {
          offlineEventInformation: id,
          actionBy: "rsvpPage",
          selectedTabID: 1,
        },
      });
    }
    this.props.socket.service("event-handler").on("event_trigger", (data) => {
      // console.log("@@@@@@@ myevent", data);
      if (
        data.event_status === "CANCELLED" ||
        data.event_status === "COMPLETED"
      ) {
        // console.log("CANCELLED, COMPLETED");
        this.props.get_single_rsvp_event_information(
          this.props.location.state.offlineEventInformation,
          this.props.auth.user.accessToken,
          this.onSuccessClick(this.props.location.state.offlineEventInformation)
        );
      } else {
        // console.log("NOT CANCELLED");
        let allRsvpInfo = this.state.getRsvpData;
        let objIndex = allRsvpInfo.findIndex((obj) => obj._id === data._id);
        allRsvpInfo[objIndex] = data;
        this.setState({
          getRsvpData: allRsvpInfo,
        });
      }
    });

    //this event will trigger on creating a new diner request
    this.props.socket.service("event-handler").on("event_request", (data) => {
      // console.log("@@@@@@@ add Event", data);
      let newObj = data;
      if (data.event_status !== "PENDING") {
        let allRsvpInfo = this.state.getRsvpData;
        allRsvpInfo.unshift(data);
        this.setState({
          getRsvpData: allRsvpInfo,
        });
      }
    });
  }

  onSuccessClick = (eventId) => (e) => {
    const token = this.props.auth.user.accessToken;
    const formData = {
      vendor_id: this.props.auth.user.VendorUser._id,
      event_id: eventId,
    };
    this.props.fetch_single_event_rsvp_data_information(
      formData,
      token,
      this.onSuccess
    );
    this.props.fetch_single_event_pending_data_information(
      formData,
      token,
      this.onSuccessPending
    );
    this.props.fetch_single_event_ticket_data_information(
      formData,
      token,
      this.onSuccessTicket
    );
  };

  onSuccess = (e) => {
    console.log("RSVP");
  };
  onSuccessPending = (e) => {
    console.log("Pending");
  };
  onSuccessTicket = (e) => {
    console.log("Ticket");
  };

  static getDerivedStateFromProps = (nextProps, nextState) => {
    if (
      !isEmpty(nextProps.getSingleEventInfo) !== nextState.getSingleEventInfo &&
      !isEmpty(nextProps.getPendingEvent) !== nextState.getPendingData &&
      !isEmpty(nextProps.getRsvpEvent) !== nextState.getRsvpData &&
      !isEmpty(nextProps.getTicketEvent) !== nextState.getTicketData
    ) {
      return {
        getSingleEventInfo: !isEmpty(nextProps.getSingleEventInfo)
          ? nextProps.getSingleEventInfo
          : {},
        getPendingData: !isEmpty(nextProps.getPendingEvent)
          ? nextProps.getPendingEvent
          : [],
        getRsvpData: !isEmpty(nextProps.getRsvpEvent)
          ? nextProps.getRsvpEvent
          : [],
        getTicketData: !isEmpty(nextProps.getTicketEvent)
          ? nextProps.getTicketEvent
          : [],
      };
    }
  };

  onAutoAcceptHandleChange = (e, data) => {
    const token = this.props.auth.user.accessToken;
    const eventId = data._id;
    const formData = {
      isRSVP_autoAccept: data.isRSVP_autoAccept === true ? false : true,
    };
    this.props.vendor_update_events(formData, eventId, token, (e) =>
      this.onSuccessRsvp(e)
    );
  };

  onSuccessRsvp = (e) => {
    Alert.success("<h4>RSVP Auto Accept Update Successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    this.props.get_single_rsvp_event_information(
      this.props.location.state.offlineEventInformation,
      this.props.auth.user.accessToken
    );
  };

  addGuestClickHandler = (id) => (e) => {
    this.props.history.push({
      pathname: `/offline-events/add-guest-event/${id}`,
      state: { addGuestInfo: id },
    });
  };

  render() {
    const {
      pathname,
      getSingleEventInfo,
      getRsvpData,
      getPendingData,
      getTicketData,
    } = this.state;
    {
      // console.log("this.props.location", this.state.pathname);
    }
    if (this.props.auth.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <Container fluid>
            <Row>
              <Media query="(min-width: 992px)">
                <div className="left-side-panel">
                  <LeftSideNavigation />
                </div>
              </Media>
              <div className="right-side-panel main-seating-dashboard-body">
                <RightSideNavigation
                  leftText={
                    this.props.vendorAccess === null
                      ? "vendorReview"
                      : "adminEvent"
                  }
                  backButtonLink="/event"
                  displayText="Back"
                  displayButton="addguest"
                  getSingleEventInfo={getSingleEventInfo}
                  // leftText={pathname.includes("superadmin") && "vendorReview"}
                  // backButtonLink={"/superadminallvendors"}
                  // displayText={"Back to Super Admin"}
                />
                <div className="container-fluid seating_dashboard_top_new_header mb-4">
                  <div className="row">
                    <div className="col-md-5 col-12">
                      <h4>Event Dashboard</h4>
                    </div>
                    <div className="col-md-4 text-right f14-500 col-12">
                      <div className="d-flex align-items-center py-4 pl-md-4">
                        <div
                          className={`${
                            getSingleEventInfo.isRSVP_autoAccept
                              ? "f16-400 mr-2"
                              : "f16-500 mr-2"
                          }`}
                        >
                          Auto Accept: RSVP &nbsp; No
                        </div>
                        <Switch
                          onChange={(e) =>
                            this.onAutoAcceptHandleChange(e, getSingleEventInfo)
                          }
                          checked={getSingleEventInfo.isRSVP_autoAccept}
                          offColor="#EEEEEE"
                          onColor="#EEEEEE"
                          offHandleColor="#212121"
                          onHandleColor="#59F832"
                          handleDiameter={24}
                          uncheckedIcon={false}
                          checkedIcon={false}
                          height={15}
                          width={41}
                          boxShadow="-2px 0px 5px #0000003B"
                          activeBoxShadow="-2px 0px 5px #0000003B"
                          id="material-switch"
                          // disabled={disabled === true ? true : false}
                        />
                        <div
                          className={`${
                            getSingleEventInfo.isRSVP_autoAccept
                              ? "f16-500 ml-2"
                              : "f16-400 ml-2"
                          }`}
                        >
                          Yes
                        </div>
                      </div>
                    </div>

                    <Media query="(min-width: 992px)">
                      <div className="col-3 text-right">
                        <button
                          className="btn btn-danger btn-lg"
                          onClick={this.addGuestClickHandler(
                            getSingleEventInfo._id
                          )}
                        >
                          + Add Guest
                        </button>
                        {/* <NavLink to="/offline-events/add-event"></NavLink> */}
                      </div>
                    </Media>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="f16-500" style={{ fontWeight: "bold" }}>
                      {getSingleEventInfo.name}
                    </span>
                    <span
                      className="badge badge-warning ml-2 f8-500 text-white"
                      style={{ padding: "5px 15px", borderRadius: 12 }}
                    >
                      {getSingleEventInfo.isOnline ? "Online" : "Offline"}
                    </span>
                  </div>
                  <span className="f12-400" style={{ color: "#EE3A23" }}>
                    Event ID: {getSingleEventInfo.event_id}
                  </span>
                </div>
                <AboveFilterDesc
                  pathname={pathname}
                  dataProps={getSingleEventInfo}
                  rsvpLength={getRsvpData.length}
                  pendingLength={getPendingData.length}
                  ticketLength={getTicketData.length}
                />
                {/* <FilterSection pathname={pathname} />  */}
                <div>
                  <OfflineEventDetailsMain
                    dataProps={getSingleEventInfo}
                    pathname={"/offline-events-rsvp"}
                    pendingData={getRsvpData}
                    // markSeatedDisplay="TicketBooked"
                  />
                </div>
                {/* <Media>desktop</Media>
                <Media>mobile</Media> */}
              </div>
              <Media query="(max-width: 991px)">
                <div className="bottom-panel">
                  <BottomNavigationMobile />
                </div>
              </Media>
            </Row>
          </Container>
        </React.Fragment>
      );
    }
  }
}

OfflineEventDetailsScreen.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  get_single_rsvp_event_information: PropTypes.func.isRequired,
  getSingleEventInfo: PropTypes.object.isRequired,
  getRsvpEvent: PropTypes.array.isRequired,
  getPendingEvent: PropTypes.array.isRequired,
  getTicketEvent: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  getSingleEventInfo: state.rsvpEvent.get_single_event_info,
  getRsvpEvent: state.rsvpEvent.single_rsvp_event_rsvp,
  getPendingEvent: state.rsvpEvent.single_rsvp_event_pending,
  getTicketEvent: state.rsvpEvent.single_rsvp_event_ticket,
  vendorAccess: state.vendorAccess,
});

const OfflineEventDetails = (props) => (
  <SocketContext.Consumer>
    {(socket) => <OfflineEventDetailsScreen {...props} socket={socket} />}
  </SocketContext.Consumer>
);

export default connect(mapStateToProps, {
  clear_all_errors,
  get_single_rsvp_event_information,
  fetch_single_event_rsvp_data_information,
  fetch_single_event_pending_data_information,
  fetch_single_event_ticket_data_information,
  vendor_update_events,
})(withRouter(OfflineEventDetails));
